import { createFileRoute } from '@tanstack/react-router';
import { AuthCallbackPage } from '@/modules/identity/public';

export const Route = createFileRoute('/auth/callback')({
  component: AuthCallbackPage,
});
